import { Injectable } from '@angular/core';
import { LocalStorageService, StorageKeys } from '@smartera/core';

@Injectable()
export class ThemeColorService {
	constructor(private readonly localStorage: LocalStorageService) {
		const themeColor = this.getUserThemeColor();
		this.setUserThemeColor(themeColor);
	}

	public getDefaultThemeColor(): string {
		return 'dayflower';
	}

	private getUserThemeColor(): string {
		return this.localStorage.getItem(StorageKeys.THEME_COLOR) ?? this.getDefaultThemeColor();
	}

	public setUserThemeColor(color: string): void {
		const oldThemeColor: string = this.localStorage.getItem(StorageKeys.THEME_COLOR);
		document.body.classList.remove(oldThemeColor);
		document.body.classList.add(color);
		this.localStorage.setItem(StorageKeys.THEME_COLOR, color);
	}
}
